import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PricingCards from '../landingPage/components/vsl/pricing';
import WhyOrder from '../landingPage/components/vsl/whyOrder';
import Gurantee from '../landingPage/components/vsl/gurantee';
import Bonuses from '../landingPage/components/vsl/Bonuses';
import Contact from '../landingPage/components/vsl/Contact';
import Testimonials from '../../components/testomonials';
import FAQ from '../landingPage/components/vsl/Faq';
import TherapistInfo from '../landingPage/components/vsl/TherapistInfo';
import ClinicalStudies from '../../components/Studies';
const V5 = () => {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
  const pricingRef = useRef(null);
  const [startTimer, setStartTimer] = useState(false);
    const [isVideoPlay, setIsVideoPlay] = useState(false);
  
  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);
      const videoParam = params.get("v");
      setIsVideoParamExists(videoParam === "y");
      setIsShowVsl(1);
    }
  }, [location]);
  useEffect(() => {
    const SECONDS_TO_DISPLAY = 10;
    let attempts = 0;
    let elsDisplayed = false;
    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);
    const showHiddenElements = () => {
      elsDisplayed = true;
      setIsVisible(true);
      localStorage.setItem(alreadyDisplayedKey, true);
    };
    const startWatchVideoProgress = () => {
      if (typeof window.smartplayer === 'undefined' || !(window.smartplayer.instances && window.smartplayer.instances.length)) {
        if (attempts >= 10) return; 
        attempts += 1;
        return setTimeout(() => { startWatchVideoProgress(); }, 1000); 
      }

      const player = window.smartplayer.instances[0];
      player.on('timeupdate', () => {
        if (elsDisplayed || player.smartAutoPlay) return;
        if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
        showHiddenElements(); 
      });

      player.on('play', () => {
        setIsVideoPlay(true);
      });

      player.on('pause', () => {
        setIsVideoPlay(false);
      });
    };
    if (alreadyElsDisplayed === 'true') {
      setTimeout(() => { showHiddenElements(); }, 100); 
    } else {
      startWatchVideoProgress(); 
    }
  }, []);
  useEffect(() => {
    if (isVisible && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [isVisible]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (pricingRef.current) observer.observe(pricingRef.current);

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (isVisible && !startTimer) {
      setStartTimer(true);
    }
  }, [isVisible, startTimer]);
  return (
    <>
      {isVideoParamExists !== null && (
        <div className="w-full">
          {isVideoParamExists ? (
            <>
              {/* vsl page */}
              <div className={isVideoPlay ? 'w-full flex items-center justify-center flex-col' : 'max-w-7xl mx-auto'}>
              <div  className={isVideoPlay ? 'hidden' : " p-3 max-w-7xl text-center flex flex-col items-center justify-center"} >
              <h3 className="md:text-2xl text-lg text-black font-bold ">
                    Top Respiratory Expert
                  </h3>
                  <p className="lg:text-4xl md:text-3xl text-2xl max-w-3xl !text-[#FF0000] font-semibold " style={{ color: "#FF0000", fontWeight: 700, lineHeight: "normalb" }}>
                      "Natural support for allergies, colds, fungi, 
                      and mucus buildup—for easier breathing!"
                    </p>
                  </div>
                  <div className='w-full flex items-center justify-center'>
                    <div
                      className={isVideoPlay ? 'w-full' : "w-2/3"}
                      dangerouslySetInnerHTML={{
                        __html: `<script type="text/javascript" id="scr_677d54bf4e05c0518227c3d5"></script>`,
                      }}

                    />

                    {/* Helmet to inject the video player script into the head */}
                    <Helmet>
                      <script type="text/javascript">
                        {`
          var s = document.createElement("script");
          s.src = "https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/677d54bf4e05c0518227c3d5/player.js";
          s.async = true;
          document.head.appendChild(s);
        `}
                      </script>
                    </Helmet>
                  </div>
                  <div id="smartplayer" style={{
                    width: '100%',
                    position: 'relative',
                    padding: '0',
                  }}></div>
                  <div className=" pt-10 p-3 max-w-7xl text-center flex flex-col items-center justify-center" >
                    <h3 className="md:text-lg text-sm max-w-3xl text-gray-700 font-semibold ">
                      <strong className='text-red-600'>
                        IMPORTANT:
                      </strong>Your video may take 10 seconds to load. Make sure your sound is on.
                    </h3>
                  </div>
                </div>
              {isVisible &&
                <div class="hide smartplayer-scroll-event" id="hidden-section">
                  <div ref={pricingRef}>
                    <PricingCards startTimer={startTimer} />
                  </div>
                  <WhyOrder />
                  <Gurantee />
                  <Bonuses />
                  <Contact />
                  <Testimonials />
                  <PricingCards startTimer={startTimer} />
                  <FAQ />
                </div>
              }
              <TherapistInfo />
              <ClinicalStudies />
            </>
          ) : (
            <div className="min-h-screen bg-navy-900">
                <PricingCards startTimer={startTimer} />
                <WhyOrder />
                  <Gurantee />
                  <Bonuses />
                  <Contact />
                  <Testimonials />
                  <PricingCards startTimer={startTimer} />
                  <FAQ />
                  <TherapistInfo />
                  <ClinicalStudies />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default V5
